export enum NotificationType {
  WORK_ORDER_COMPLETED = 'WORK_ORDER_COMPLETED',
  WORK_ORDER_READY_FOR_PICKUP = 'WORK_ORDER_READY_FOR_PICKUP',
  WORK_ORDER_ASSIGNED = 'WORK_ORDER_ASSIGNED',
  WORK_ORDER_CREATED = 'WORK_ORDER_CREATED',
  WORK_ORDER_UPDATED = 'WORK_ORDER_UPDATED',
  SYSTEM = 'SYSTEM',
}

export interface Notification {
  id: number
  userId: number
  title: string
  message: string
  type: NotificationType
  relatedEntityType?: string
  relatedEntityId?: number
  isRead: boolean
  readAt?: string
  createdAt: string
}
